import React, { FC } from 'react'

import { IconGameConsoleProps } from './IconGameConsole.types'
import * as Styled from './styles/IconGameConsole.style'

import { nonThemeableRules } from '../../ruleSet'

const IconGameConsole: FC<IconGameConsoleProps> = ({
  size = nonThemeableRules.defaultSize as number as IconGameConsoleProps['size'],
  isResponsive = false,
}: IconGameConsoleProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M16 18.063v6m-3-3h6' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M24 27.332a9.99 9.99 0 0 1 2.523.332 9.772 9.772 0 0 1 2.317.938 9.985 9.985 0 0 1 4.625 5.597 4.285 4.285 0 0 0 1.75 2.172 4.982 4.982 0 0 0 2.676.832h.093a5.03 5.03 0 0 0 4.11-2.152c1.172-1.692.91-3.75.625-5.664a25.898 25.898 0 0 0-1.344-5.277 23.746 23.746 0 0 0-2.32-4.641c-1.805-2.817-4.266-5.469-7.207-7.082a3.892 3.892 0 0 0-2.055-.5c-2.172.054-3.637 1.133-5.793 1.156-2.156-.023-3.621-1.101-5.793-1.156a3.892 3.892 0 0 0-2.055.5C13.211 14 10.75 16.652 8.945 19.46a23.773 23.773 0 0 0-2.32 4.645 25.862 25.862 0 0 0-1.344 5.273c-.285 1.922-.547 3.973.625 5.668a5.03 5.03 0 0 0 4.11 2.152h.093a4.953 4.953 0 0 0 2.676-.836 4.269 4.269 0 0 0 1.75-2.172 10.026 10.026 0 0 1 6.942-6.535A10.004 10.004 0 0 1 24 27.332Z'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M29.512 21.063c0 .28-.23.511-.512.511a.513.513 0 0 1-.512-.512c0-.28.23-.511.512-.511.281 0 .512.23.512.512Zm6 0c0 .28-.23.511-.512.511a.513.513 0 0 1-.512-.512c0-.28.23-.511.512-.511.281 0 .512.23.512.512Zm-3-3c0 .28-.23.511-.512.511a.513.513 0 0 1-.512-.512c0-.28.23-.511.512-.511.281 0 .512.23.512.512Zm0 6c0 .28-.23.511-.512.511a.513.513 0 0 1-.512-.512c0-.28.23-.511.512-.511.281 0 .512.23.512.512Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconGameConsole
